// extracted by mini-css-extract-plugin
export default {"title":"E1yMu","description":"HgsvN"};